import request from './request'

// 删除买量事件
export const deleteBuyEvent = data => request('/buyEvent/delete', data, 'GET')
// 获取买量事件详情
export const getBuyEventDetail = data => request('/buyEvent/detail', data, 'GET')
// 获取买量事件分页列表
export const getBuyEventPageList = data => request('/buyEvent/pageList', data, 'POST_JSON')
// 保存买量事件
export const saveBuyEvent = data => request('/buyEvent/save', data, 'POST_JSON')
// 更新买量事件状态
export const updateBuyEventStatus = data => request('/buyEvent/updateStatus', data, 'GET')
// 获取买量事件枚举
export const getBuyEventEnumAll = () => request('/buyEvent/enum/all', null, 'GET')

// 保存买量事件草稿
export const saveBuyEventDraft = data => request('/buyEvent/saveDraft', data, 'POST_JSON')

// 获取买量事件草稿
export const getBuyEventDraft = () => request('/buyEvent/getDraft', null, 'GET')

// 删除买量事件草稿
export const deleteBuyEventDraft = () => request('/buyEvent/deleteDraft', null, 'POST_JSON')

// 获取游戏模式交集
export const getGameModeIntersect = data => request('/buyEventMerged/gameModeIntersect', data, 'POST_JSON')

// 获取广告类型交集
export const getAdzCodeIntersect = data => request('/buyEventMerged/adzCodeIntersect', data, 'POST_JSON')

// 复制买量事件到目标产品
export const copyBuyEvent = data => request('/buyEvent/copy', data, 'POST_JSON')

// 批量删除买量事件
export const batchDeleteBuyEvent = data => request('/buyEvent/batchDelete', data, 'POST_JSON')

// 批量复制买量事件
export const batchCopyBuyEvent = data => request('/buyEventMerged/batchCopy', data, 'POST_JSON')

// 批量删除买量事件
export const batchDeleteBuyEventMerged = data => request('/buyEventMerged/batchDelete', data, 'POST_JSON')

// 复制买量事件
export const copyBuyEventMerged = data => request('/buyEventMerged/copy', data, 'POST_JSON')

// 删除买量事件
export const deleteBuyEventMerged = data => request('/buyEventMerged/delete', data, 'GET')

// 获取买量事件详情
export const getBuyEventMergedDetail = data => request('/buyEventMerged/detail', data, 'GET')

// 获取买量事件分页列表
export const getBuyEventMergedPageList = data => request('/buyEventMerged/pageList', data, 'POST_JSON')

// 查询已配置服务端事件的产品下拉列表
export const getBuyEventMergedProductList = data => request('/buyEventMerged/productList', data, 'GET')

// 创建买量事件
export const createBuyEventMerged = data => request('/buyEventMerged/create', data, 'POST_JSON')

// 更新买量事件
export const updateBuyEventMerged = data => request('/buyEventMerged/update', data, 'POST_JSON')

// 保存买量事件
export const saveBuyEventMerged = data => request('/buyEventMerged/save', data, 'POST_JSON')

// 更新买量事件状态
export const updateBuyEventMergedStatus = data => request('/buyEventMerged/updateStatus', data, 'GET')
